import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {CheckBox, Create} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {ISinglePlate} from '../store/types';
import ItemConfirmSingleVoting from './ItemConfirmSingleVoting';

interface IPropsDialog {
  open: boolean;
  plates: ISinglePlate[];
  onClose: (action: string) => void;
}

const ConfirmSingleVotingDialog: React.FC<IPropsDialog> = ({
  open,
  plates,
  onClose,
}) => {
  const {t} = useTranslation();
  const handleCancel = () => {
    onClose('cancel');
  };

  const handleOk = () => {
    onClose('confirm');
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleCancel}
      className="confirm-voting-dialog"
    >
      <DialogTitle>
        {t('confirmar-votacao-simples.confirme-seu-voto')}
      </DialogTitle>
      <DialogContent>
        {plates.map(value => {
          return (
            <ItemConfirmSingleVoting election={value} key={value.plate.id} />
          );
        })}

        <DialogContentText>
          {t('confirmar-votacao-simples.clique-corrigir-ou-confirmar')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          className={`button-default  full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={handleCancel}
          startIcon={<Create />}
        >
          {t('geral.corrigir')}
        </Button>

        <Button
          className={`button-default btn-green  full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={handleOk}
          startIcon={<CheckBox />}
        >
          {t('geral.confirmar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmSingleVotingDialog;



// WEBPACK FOOTER //
// ./src/features/election-single/components/ConfirmSingleVotingDialog.tsx